import { connect } from "react-redux";
import * as usersActions from "../users/actions";
import * as creditSettlementActions from "../creditSettlement/actions";
import * as userLoanActions from "./user.actions";

import moment from "moment";

function mapStateToProps(state) {
  return {
    loans: state.userLoans,
    adHocDataPending: state.users.adHocDataPending,
    adHocDataComplete: state.users.adHocDataComplete,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLoans: (id, paidOut, exported, fullyPaid, offset, take) => {
      dispatch(
        creditSettlementActions.get_settlements(
          id,
          paidOut,
          exported,
          fullyPaid,
          offset,
          take,
        ),
      );
    },

    getLoanDetails: (id, accountId) => {
      dispatch(creditSettlementActions.get_loan_details(id, accountId));
    },

    changeLoanListPage: (page) => {
      dispatch(userLoanActions.change_loan_list_page(page));
    },

    changeLoanListFilter: (type, key, value, valueKey, prevFilter) => {
      dispatch(
        userLoanActions.change_loan_list_filter(
          key,
          value,
          type,
          valueKey,
          prevFilter,
        ),
      );
    },

    fullRepayment: (loanId, accountId, date, amount) => {
      date = moment(date).format("YYYY-MM-DD");
      dispatch(userLoanActions.full_repayment(loanId, accountId, date, amount));
    },

    getFullRepayment: (loanId, date) => {
      date = moment(date).format("YYYY-MM-DD");
      dispatch(userLoanActions.get_full_repayment(loanId, date));
    },

    removeFees: (data, removalType) => {
      dispatch(userLoanActions.remove_fees(data, removalType));
    },

    getAdHocDataPendingForId: (creditId) => {
      dispatch(usersActions.get_ad_hoc_pending_data_for_credit_id(creditId));
    },

    getAdHocDataCompleteForId: (creditId) => {
      dispatch(usersActions.get_ad_hoc_complete_data_for_credit_id(creditId));
    },

    updateLoanStatus: (creditId, asOfDate) => {
      asOfDate = moment(asOfDate).format("YYYY-MM-DD");

      dispatch(userLoanActions.update_loan_status(creditId, asOfDate));
    },

    addToDCAProcess: (creditId) => {
      dispatch(creditSettlementActions.add_to_dca_process(creditId));
    },

    closeDCAProcess: (creditId) => {
      dispatch(creditSettlementActions.close_dca_process(creditId));
    },

    addDCAMonthlyRepayment: (
      principalAmount,
      interestAmount,
      feesAmount,
      OCR,
      bankReceiveDate,
      lastPayment,
    ) => {
      dispatch(
        creditSettlementActions.add_dca_monthly_repayment(
          principalAmount,
          interestAmount,
          feesAmount,
          OCR,
          bankReceiveDate,
          lastPayment,
        ),
      );
    },
  };
}

const userLoanConnector = connect(mapStateToProps, mapDispatchToProps);
export default userLoanConnector;
